import { useMutation, useQueryClient } from '@tanstack/react-query'
import { saveDemographicAnswer, deleteDemographicAnswer } from '../processHandlers/demographics'
import { DemographicQuestionId } from '../../../../pure-js/types/Demographics'
import { QUERY_KEYS } from '../queryKeys'

export const useSaveDemographicAnswer = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (params: {
      userId: string
      questionId: DemographicQuestionId
      answer: number
      otherText?: string | null
    }) => saveDemographicAnswer(params),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER_DEMOGRAPHICS, variables.userId] })
    }
  })
}

export const useDeleteDemographicAnswer = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (params: { userId: string; questionId: DemographicQuestionId }) => deleteDemographicAnswer(params),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER_DEMOGRAPHICS, variables.userId] })
    }
  })
}
